// AUTO-GENERATED by assets/prepare.ts — DO NOT EDIT

export const enum Asset {
  font_acme_caps_outline = "Qdc3ye36.ttf",
  font_press_start = "z2HaDFJU.ttf",
  gfx_bg_forest0 = "RD6HU0Wu.png",
  gfx_bg_forest1 = "vB-tSll4.png",
  gfx_bg_forest2 = "snbpU8DV.png",
  gfx_bird = "bTfOQ1MP.png",
  gfx_coin = "sVHJcasw.png",
  gfx_copter = "mtcq7EBk.png",
  gfx_eye_debug = "ckfWakPQ.png",
  gfx_heart = "-gwJZUps.png",
  gfx_outline_grass = "6yMhqAP1.png",
  gfx_outline_ground = "aXAetvFg.png",
  gfx_outline_lava = "dCkohNHh.png",
  gfx_outline_snow = "Zz5dPP-F.png",
  gfx_outline_stone = "53D-ovy3.png",
  gfx_tile_mountain = "ymrfA6Gh.png",
  gfx_tile_sand = "QYWt7wWy.png",
  gfx_tile_snow = "a9z7cv-d.png",
  gfx_tile_stone = "w9WaeC8t.png",
  gfx_tile_swamp = "_fZpjahP.png",
  gfx_turret_gun = "pjS3Ieym.png",
  gfx_turret_tower = "Qvszn1n9.png",
  i18n = "xsOb2lh7.json",
  sfx_bullet_hit = "LxmIsgYv.mp3",
  sfx_coin_collect = "zvS3jw9x.mp3",
  sfx_explosion = "KVq4M1Qx.mp3",
  sfx_kick = "YDAMJVYF.mp3",
  sfx_lift_down = "P0xDxUy5.mp3",
  sfx_lift_up = "y7APJvGr.mp3",
  sfx_speed_up = "Jn34Vq8M.mp3",
  sfx_tune = "3lFx4so5.mp3",
  sfx_turret_shoot = "eM3fHpCt.mp3",
}
